/**
 *
 * PermissionTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.blue};
    background: ${COLORS.blueLight};
    border-color: ${COLORS.blue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.blue};
    }
  }
`;

function PermissionTag({ label, ...props }) {
  return <StyledTag label={label} {...props} />;
}

PermissionTag.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(PermissionTag);
